import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import { CREDIT_NOTE, REFUND } from '~/const/help';
import MdmSelect from '~/components/atoms/MdmSelect.vue';
export default {
  name: 'ChooseSolutionProductReturn',
  components: {
    MdmSelect
  },
  props: {
    solutions: {
      type: Array,
      required: true
    },
    channel: {
      type: String,
      required: true
    },
    displayOnlyRefund: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      selected: null
    };
  },

  computed: _objectSpread(_objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })), {}, {
    solutionWithLabel() {
      if (this.locale.market === 'UK') {
        return this.solutions.filter(solution => solution !== CREDIT_NOTE).map(solution => ({
          id: solution,
          label: this.$t(solution)
        }));
      }

      if (this.locale.market === 'UK' && this.displayOnlyRefund) {
        return [{
          id: REFUND,
          label: this.$t(REFUND)
        }];
      }

      return this.solutions.map(solution => ({
        id: solution,
        label: this.$t(solution)
      }));
    }

  }),
  methods: {
    emitSolutionData() {
      this.$emit('update-solution', {
        value: this.selected,
        label: this.$t(this.selected)
      });
    }

  }
};